import { Box } from '@mui/material';
import React, { useEffect } from "react";

const Background = ({ children }) => {

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            @keyframes bgMove {
                0% { background-position: left center; }
                50% { background-position: right center; }
                100% { background-position: left center; }
            }
            .animated-bg {
                animation: bgMove 100s ease-in-out infinite;
            }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);
    
    return (
        <Box
            className="animated-bg"
            sx={{
                width: '100vw',
                minHeight: '100vh',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundImage: 'url("/dadoggo.jpg")',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundAttachment: 'flexible',
                margin: -1,
            }}
        >
            {children}
        </Box>
    );
};
export default Background;